// Same localStorage-backed permission check already used for route gating
// (Context/ProtectedRoute.js) and the sidebar menu (common/Sidebar/Sidebar.js)
// - this is the first place it's used to gate a button/element INSIDE a
// page rather than a whole route or menu item, so components needing that
// should import this rather than re-reading localStorage/JSON.parse-ing
// permissions themselves.
const usePermissions = () => {
    const role = localStorage.getItem("role");
    const isSuperAdmin = role === "superadmin" || localStorage.getItem("is_superuser") === "true";

    let permissions = [];
    try {
        permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
    } catch (e) {
        permissions = [];
    }

    const hasPermission = (code) => isSuperAdmin || permissions.includes(code);

    return { isSuperAdmin, permissions, hasPermission };
};

export default usePermissions;
